import { lazy, useEffect } from "react";

import InitializeData from "../functional-components/InitializeData";
import Tracking from "../functional-components/Tracking";
import "../style/bjelin.scss";
import "../config/i18next";
import { cockpitCollectionPreviewDataListener } from "../utils/CockpitUtils";
import { ToolTipProvider } from "../components/ToolTip/Context";
import { CartContextProvider } from "../functional-components/CartContext";
import { UserContextProvider } from "../functional-components/UserContext";
import { UiMessageContextProvider } from "../components/UIMessages/context";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { reCaptchaSiteKey } from "../config/reCaptcha";
import { CssVariableContextProvider } from "../functional-components/CssVariableContext";
import { ConsentManagerProvider } from "@pervanovo/bjelin-consent-manager";
import { useConsentVendors } from "../hooks/ConsentHooks";
import PrerenderRedirectStatus from "../components/PrerenderRedirectStatus";

const Routes = lazy(() => import("../components/Routes"));
const PrintRoutes = lazy(async () => ({
  default: (await import("../components/Routes")).PrintRoutes
}));

const Layout = ({ print = false }) => {
  useEffect(() => {
    window.addEventListener("message", cockpitCollectionPreviewDataListener);

    return () =>
      window.removeEventListener(
        "message",
        cockpitCollectionPreviewDataListener
      );
  }, []);
  const consentVendors = useConsentVendors();
  return (
    <>
      <Tracking />
      <CssVariableContextProvider>
        <GoogleReCaptchaProvider reCaptchaKey={reCaptchaSiteKey}>
          <UiMessageContextProvider>
            <UserContextProvider>
              <InitializeData>
                <CartContextProvider>
                  <ToolTipProvider>
                    <ConsentManagerProvider availableVendors={consentVendors}>
                      <PrerenderRedirectStatus />
                      {print ? <PrintRoutes /> : <Routes />}
                    </ConsentManagerProvider>
                  </ToolTipProvider>
                </CartContextProvider>
              </InitializeData>
            </UserContextProvider>
          </UiMessageContextProvider>
        </GoogleReCaptchaProvider>
      </CssVariableContextProvider>
    </>
  );
};

export default Layout;
